import React, {Component, Fragment} from 'react'
import FormColumn from '../../../Templates/FormColumn';
import { SORT, toggleSorting } from '../../../Templates/functions'
import {WebSocketEventEmitter} from "../../../Websockets/WebSocketEventEmitter";
import {renderDateAndTime} from '../../../Templates/functions'
import { multipleShortCellsSkeleton, multipleLongCellsSkeleton, multipleMediumCellsSkeleton, multipleShortCellsSkeletonCentered } from '../../../Templates/icons';
class FeedbackWidget extends Component {
    state = {
        sortingByUsername: 2,
        sortingByWIName: 2,
        sortingByDate: 1
    }

    componentDidMount = () => {
        const msg = {
            eventSource: 'identify_user',
            sender: "Feedback Widget",
            currentUserId: this.props.currentUser._id,
            currentUserRole: this.props.currentUser.role
        }
        WebSocketEventEmitter.emit('WSListener', msg);
    }

    render = () => {
        let feedback = Object.values(this.props.feedback || {})
        feedback = SORT(1, feedback, 'date')
        if (this.state.sortingByUsername) {
            feedback = SORT(this.state.sortingByUsername, feedback, "username")
        }
        if (this.state.sortingByWIName) {
            feedback = SORT(this.state.sortingByWIName, feedback, "wip_name")
        }
        if (this.state.sortingByDate) {
            feedback = SORT(this.state.sortingByDate, feedback, "date")
        }

        let usernames = []
        let workInstructionNames = []
        let comments = []
        let dates = []

        feedback.forEach(feedback => {
            usernames.push(feedback.username)
            workInstructionNames.push(feedback.wip_name)
            comments.push(feedback.comment)
            dates.push(renderDateAndTime(feedback.date))
        })



        return  <Fragment> 
                    <h3 id="feedback-header" className="flex-centered">FEEDBACK</h3>
                    <div id="columns-container" className="flex overflow">
                {this.props.isLoading ?
                    <Fragment>
                        <FormColumn title={"Date"} columnWidth={"170px"} sort={() => toggleSorting(this.state.sortingByDate, (value) => this.setState({ sortingByUsername: 0, sortingByWIName: 0, sortingByDate: value }))} sorting={this.state.sortingByDate} content={multipleShortCellsSkeletonCentered} numColumns={4} />
                        <FormColumn title={"User"} columnWidth={"200px"} sort={() => toggleSorting(this.state.sortingByUsername, (value) => this.setState({ sortingByUsername: value, sortingByWIName: 0, sortingByDate: 0 }))} sorting={this.state.sortingByUsername} content={multipleShortCellsSkeleton} numColumns={4} />
                        <FormColumn title={"Work Instruction"} columnWidth={"350px"} sort={() => toggleSorting(this.state.sortingByWIName, (value) => this.setState({ sortingByUsername: 0, sortingByWIName: value, sortingByDate: 0 }))} sorting={this.state.sortingByWIName} content={multipleLongCellsSkeleton} numColumns={4} />
                        <FormColumn title={"Comment"} columnWidth={"calc(100% - 720px)"} content={multipleMediumCellsSkeleton} numColumns={4} nullSort={true} />
                    </Fragment>
                    :
                    <Fragment>
                        <FormColumn title={"Date"} columnWidth={"170px"} sort={() => toggleSorting(this.state.sortingByDate, (value) => this.setState({ sortingByUsername: 0, sortingByWIName: 0, sortingByDate: value }))} sorting={this.state.sortingByDate} content={dates} numColumns={4}/>
                        <FormColumn title={"User"} columnWidth={"200px"} sort={() => toggleSorting(this.state.sortingByUsername, (value) => this.setState({ sortingByUsername: value, sortingByWIName: 0, sortingByDate: 0 }))} sorting={this.state.sortingByUsername} content={usernames} numColumns={4}/>
                        <FormColumn title={"Work Instruction"} columnWidth={"350px"} sort={() => toggleSorting(this.state.sortingByWIName, (value) => this.setState({ sortingByUsername: 0, sortingByWIName: value, sortingByDate: 0 }))} sorting={this.state.sortingByWIName}  content={workInstructionNames} numColumns={4}/>
                        <FormColumn title={"Comment"} columnWidth={"calc(100% - 720px)"} content={comments} numColumns={4} nullSort={true}/>
                    </Fragment>}
                </div>
            </Fragment>
    }
}

export default FeedbackWidget
